import { render, staticRenderFns } from "./activityLevel.vue?vue&type=template&id=2365f477&scoped=true&"
import script from "./activityLevel.vue?vue&type=script&lang=js&"
export * from "./activityLevel.vue?vue&type=script&lang=js&"
import style0 from "./activityLevel.vue?vue&type=style&index=0&id=2365f477&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2365f477",
  null
  
)

export default component.exports